import {
  Casino,
  // Dashboard,
  // EmojiEvents,
  Leaderboard,
  Paid,
  Savings,
} from '@mui/icons-material';

const now = new Date();

export const DEFAULT_PERIOD = {
  year: now.getFullYear(),
  month: now.getMonth() + 1,
};

export const MONTH_OPTIONS = [
  { value: 1, label: 'Enero' },
  { value: 2, label: 'Febrero' },
  { value: 3, label: 'Marzo' },
  { value: 4, label: 'Abril' },
  { value: 5, label: 'Mayo' },
  { value: 6, label: 'Junio' },
  { value: 7, label: 'Julio' },
  { value: 8, label: 'Agosto' },
  { value: 9, label: 'Septiembre' },
  { value: 10, label: 'Octubre' },
  { value: 11, label: 'Noviembre' },
  { value: 12, label: 'Diciembre' },
];

export const TAB_ITEMS = [
  // TAB EN DESARROLLO { label: 'Dashboard', icon: Dashboard },
  // TAB EN DESARROLLO { label: 'Dashboard por grupo', icon: Dashboard },
  { label: 'Fondo Puntaje', icon: Paid },
  { label: 'Fondo Sorteo', icon: Casino },
  { label: 'Ranking', icon: Leaderboard },
  // TAB EN DESARROLLO { label: 'Preadjudicaciones', icon: EmojiEvents },
  // TAB EN DESARROLLO { label: 'Loteria', icon: Casino },
  { label: 'Saldos Iniciales', icon: Savings },
];

export const FUND_TYPE_OPTIONS = [
  { value: 'PUNTAJE', label: 'Fondo Puntaje' },
  { value: 'SORTEO', label: 'Fondo Sorteo' },
];

export const PRE_ADJ_SECTIONS = [
  { key: 'PUNTAJE', title: 'Preadjudicaciones por Puntaje' },
  { key: 'SORTEO', title: 'Preadjudicaciones por Sorteo' },
  { key: 'DESBORDE', title: 'Preadjudicaciones por Desborde' },
];
